import { render, staticRenderFns } from "./PluginCookiesConsent.vue?vue&type=template&id=2898144e"
import script from "./PluginCookiesConsent.vue?vue&type=script&lang=js"
export * from "./PluginCookiesConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2898144e')) {
      api.createRecord('2898144e', component.options)
    } else {
      api.reload('2898144e', component.options)
    }
    module.hot.accept("./PluginCookiesConsent.vue?vue&type=template&id=2898144e", function () {
      api.rerender('2898144e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginCookiesConsent.vue"
export default component.exports